<template>
  <div class="home">
    <!--<img alt="Vue logo" src="../assets/logo.png">-->
    <!--<HelloWorld msg="Welcome to Your Vue.js App"/>-->
    <h3>Mit freundlicher Hilfe unserer Unterstützer in 2026</h3>
    <vueMarqueeSlider id="marquee-slider-cards"
    :speed="15000"
    :height="70"
    :width="160"
    :space="50">
        <img v-for="(src, index) in sponsorImages" :key="index" :src="src" />
    </vueMarqueeSlider>
    <GlobalProgress />
    <div class="spacer-small"></div>
    <LeaderboardUsers />
    <div class="spacer-small"></div>
    <LeaderboardTeams />
    <div class="spacer-small"></div>
    <LeaderboardCompanies />
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import GlobalProgress from '@/components/GlobalProgress.vue';
import LeaderboardUsers from '@/components/leaderboards/LeaderboardUsers.vue';
import LeaderboardTeams from '@/components/leaderboards/LeaderboardTeams.vue';
import vueMarqueeSlider from '../components/vue-marquee-slider.vue';
import LeaderboardCompanies from '@/components/leaderboards/LeaderboardCompanies.vue';

export default {
  name: 'Home',
  components: {
    GlobalProgress,
    LeaderboardUsers,
    LeaderboardTeams,
    LeaderboardCompanies,
    vueMarqueeSlider,
  },
  data() {
    return {
      baseUrl: window.baseroute,
    }
  },
  computed: {
    sponsorImages() {
        if(window.kgkSponsors && Array.isArray(window.kgkSponsors)) {
            return window.kgkSponsors.map(sponsor => this.baseUrl + '/storage/' + sponsor.logo)
        }
        return [];
    },
  }
}
</script>
